export const STO_RECEIVE_ROUTE_ROOT = '/sto-receive';

export const STO_RECEIVE_ROUTES = {
  STO_RECEIVE: STO_RECEIVE_ROUTE_ROOT,
  ASSIGN: `${STO_RECEIVE_ROUTE_ROOT}/assign`,
  LIST: `${STO_RECEIVE_ROUTE_ROOT}/list`,
  ITEM: `${STO_RECEIVE_ROUTE_ROOT}/item`,
  SUMMARY: `${STO_RECEIVE_ROUTE_ROOT}/summary`,
} as const;
